// extracted by mini-css-extract-plugin
export default {"component":"Badge_component__a7wir","element":"Badge_element__B3Ivd"};